import { uid } from '../../../../lib/uid';

/**
 * Test-data generator backing the Autogenerate button on the create-role form.
 *
 * Fills every required field so the primary action enables on the first try. Keep this in
 * lockstep with the form: a new required field must be added here in the same change, or
 * Autogenerate silently stops working.
 *
 * Values are synthetic.
 */

const SUBJECTS = ['Records', 'Inventory', 'Procurement', 'Registry', 'Cashier', 'Archives'];
const DUTIES = ['Clerk', 'Officer', 'Encoder', 'Reviewer', 'Custodian'];

function pick<T>(values: readonly T[]): T {
  return values[Math.floor(Math.random() * values.length)];
}

export interface SampleRole {
  name: string;
  description: string;
}

export function sampleRole(): SampleRole {
  const subject = pick(SUBJECTS);
  const duty = pick(DUTIES);

  /*
    The suffix keeps repeated clicks from colliding — the service refuses a duplicate name
    with a 409, which would otherwise make the second press look like a broken button.

    It is stripped to letters and digits because the server's own rule is narrower than a
    uid: a role name may hold letters, digits, spaces, hyphens and underscores and nothing
    else, so a raw uid would generate a name its own validator rejects.
  */
  const suffix = uid().replace(/[^A-Za-z0-9]/g, '').slice(0, 5);

  return {
    name: `${subject} ${duty} ${suffix}`,
    description: `Sample role for the ${subject.toLowerCase()} desk, created from Autogenerate.`,
  };
}
